import React, { useState, useCallback, useEffect } from 'react';
import { Space, Table } from 'antd';
import Filter from './Filter'
import { dateTimeRender, textRender } from '../../utils';
import { searchSystemLogs, SearchSystemLogsParams } from '../../api/logs';
const { Column } = Table;

const Systemlogs: React.FC = () => {
    const [params, setParams] = useState<Partial<Omit<SearchSystemLogsParams, 'pageNum' | 'pageSize'>>>({
        createTimeQueryStartDate: dateTimeRender(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
        createTimeQueryEndDate: dateTimeRender(new Date().getTime()),
    });
    const [pagination, setPagination] = useState<Pick<SearchSystemLogsParams, 'pageNum' | 'pageSize'>>({
        pageNum: 1, pageSize: 10
    });
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<PagedData<SystemLog>>({
        pageNum: 1,
        pageSize: 10,
        total: 0,
        data: [],
    });
    const fetchData = useCallback(() => {
        setLoading(true);
        searchSystemLogs({ ...params, ...pagination })
            .then(setData)
            .finally(() => { setLoading(false) });
    }, [params, pagination]);

    useEffect(fetchData, [fetchData]);

    return (
        <>
            <Space>
                <Filter values={params} onChange={setParams} onSearch={fetchData} />
            </Space>
            <br />
            <br />
            <Table<SystemLog> rowKey='id'
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.pageNum,
                    total: data.total,
                    onChange: (pageNum, pageSize) => {
                        setPagination({
                            ...pagination,
                            pageSize,
                            pageNum
                        })
                    }
                }} loading={loading} dataSource={data.data}>
                <Column title="用户名" width={100} dataIndex="username" key="username" render={textRender} />
                <Column title="模块" width={100} dataIndex="module" key="module" render={textRender} />
                <Column title="操作" width={150} dataIndex="action" key="action" render={textRender} />
                <Column title="操作内容" dataIndex="content" key="content" render={textRender} />
                <Column title="请求URL" dataIndex="requestUrl" key="requestUrl" render={textRender} />
                <Column title="响应状态码" width={130} dataIndex="responseCode" key="responseCode" render={textRender} />
                <Column title="操作时间" width={200} dataIndex="createDatetime" key="createDatetime" render={textRender} />
            </Table>
        </>
    );
}

export default Systemlogs;